"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var utilities_1 = require("../../utilities");
var FunctionOrNode_1 = require("../FunctionOrNode");
var IdentityContext_1 = require("../IdentityContext");
exports.WithPolicy = function (_a) {
    var input = _a.input, policy = _a.policy, children = _a.children, _b = _a.fallback, fallback = _b === void 0 ? null : _b;
    var _c = __read(React.useState(false), 2), isPermitted = _c[0], setPermitted = _c[1];
    React.useEffect(function () {
        try {
            utilities_1.evaluatePolicy(policy, input).then(function (result) {
                setPermitted(result.allowed);
            });
        }
        catch (error) {
            // tslint:disable-next-line:no-console
            console.error(error);
        }
    }, [input]);
    return (React.createElement(IdentityContext_1.IdentityConsumer, null, function () {
        if (isPermitted) {
            return React.createElement(FunctionOrNode_1.FunctionOrNode, null, children);
        }
        return React.createElement(FunctionOrNode_1.FunctionOrNode, null, fallback);
    }));
};
exports.WithPolicy.displayName = 'WithPolicy';
